/**
 * memberApi.js — admin client for /api/club/admin/members endpoints.
 * FIR-20260611-001
 */
import { consoleApi } from "@/lib/console-auth";
import { resolveBackendUrl } from "@/lib/backend-url";

export async function listMembers(params = {}) {
  const { data } = await consoleApi.get("/club/admin/members", { params });
  return data;
}
export async function getMember(card) {
  const { data } = await consoleApi.get(`/club/admin/members/${encodeURIComponent(card)}`);
  return data.member;
}
export async function createMember(payload) {
  const { data } = await consoleApi.post("/club/admin/members", payload);
  return data;
}
export async function patchMember(card, patch) {
  const { data } = await consoleApi.patch(`/club/admin/members/${encodeURIComponent(card)}`, patch);
  return data;
}
export async function deleteMember(card, { hard = false, reason = "" } = {}) {
  const params = {};
  if (hard) params.hard = true;
  if (reason) params.reason = reason;
  const { data } = await consoleApi.delete(`/club/admin/members/${encodeURIComponent(card)}`, { params });
  return data;
}
export async function bulkAuthorise(cards, authorised) {
  const { data } = await consoleApi.post("/club/admin/members/bulk-authorise", { cards, authorised });
  return data;
}
export async function uploadMemberPhoto(card, slot, file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await consoleApi.post(
    `/club/admin/members/${encodeURIComponent(card)}/photo`,
    form,
    { headers: { "Content-Type": "multipart/form-data" }, params: { slot } },
  );
  return data;
}
export async function deleteMemberPhoto(card, slot) {
  const { data } = await consoleApi.delete(
    `/club/admin/members/${encodeURIComponent(card)}/photo`,
    { params: { slot } },
  );
  return data;
}
export async function sendWelcomeEmail(card) {
  const { data } = await consoleApi.post(
    `/club/admin/members/${encodeURIComponent(card)}/welcome`,
  );
  return data;
}
export async function importMembersCsv(file, tenant = "") {
  const form = new FormData();
  form.append("file", file);
  const params = tenant ? { tenant } : {};
  const { data } = await consoleApi.post("/club/admin/members/import-csv", form, {
    headers: { "Content-Type": "multipart/form-data" }, params,
  });
  return data;
}
export function exportMembersCsvUrl(tenant = "", authorised = "") {
  const base = resolveBackendUrl();
  const p = new URLSearchParams();
  if (tenant) p.set("tenant", tenant);
  if (authorised !== "") p.set("authorised", authorised);
  return `${base}/api/club/admin/members/export-csv?${p.toString()}`;
}

export async function importClubsCsv(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await consoleApi.post("/club/admin/clubs/import-csv", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
export function exportClubsCsvUrl(offerable = "") {
  const base = resolveBackendUrl();
  const p = new URLSearchParams();
  if (offerable !== "") p.set("offerable", offerable);
  return `${base}/api/club/admin/clubs/export-csv?${p.toString()}`;
}
export function exportClubsXlsxUrl(offerable = "") {
  const base = resolveBackendUrl();
  const p = new URLSearchParams();
  if (offerable !== "") p.set("offerable", offerable);
  return `${base}/api/club/admin/clubs/export-xlsx?${p.toString()}`;
}
